import { Component, OnInit, Inject, Optional } from '@angular/core';
import { BaseComponent } from '@tytapp/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpressResponse } from '@tytapp/common';
import { RESPONSE } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends BaseComponent {

  constructor(
    private route : ActivatedRoute,
    @Inject(RESPONSE) @Optional()
    private response : ExpressResponse,
    private router : Router
  ) {
    super();
  }

  async init() {
    if (this.response) {
      this.response.status(404);
      this.response.header('Cache-Control', 'no-cache');
    }
  }

}
